module.exports = __webpack_public_path__ + "static/media/call_center.895f4b28.png";